import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Gate for routes that need a logged-in user - the client-side mirror of the
 * API's authMiddleware.
 *
 * This is CONVENIENCE, not security. Anyone can edit the JavaScript running in
 * their own browser; the only thing that actually protects data is the API
 * rejecting the request. This just avoids showing a page that would be empty.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Wait for the initial /auth/me check. Without this, a page refresh would
  // bounce a logged-in user to /login for a split second.
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-slate-500">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    // `state.from` lets the login page send them back where they were going.
    // `replace` keeps the guarded URL out of history, so Back does not loop.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
